export const trimTextByWord = (
  name: string,
  maxElementNameLength: number = 45
): string => {
  let threeDots = "";
  if (!name) {
    name = "";
  }
  let trimedName = "";
  const words = name.split(" ");
  for (const word of words) {
    if (trimedName.length > maxElementNameLength) {
      break;
    }
    trimedName += word + " ";
  }
  if (name.length > maxElementNameLength) {
    threeDots = "...";
  }
  trimedName = trimedName.trim();
  if (trimedName[trimedName.length - 1] === ",") {
    trimedName = trimedName.replace(/.$/, "");
  }
  return trimedName + threeDots;
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/utils/trimTextByWord.ts